import DataTable from 'react-data-table-component';
import React from 'react'
import Statusall from './statusall';
import Flowuserapprove from './flowuserapprove';
import { FaList, FaFileSignature, FaArchive, FaExclamationTriangle, FaCheck, FaCheckCircle } from "react-icons/fa";
import PopUpCheckList from '../componentjournallistrecieved/popUpCheckList';


const columns = [
    {
        name: 'TDS code',
        sortable: true,
       width: '120px',
        selector: row => row.tdscode,
    },
    {
        name: 'v',
         width: '50px',
        // sortable: true,
        selector: row => row.revision,
    },
    {
        name: 'date',
        // grow: 1,
        sortable: true,
        width: '110px',
        selector: row => row.createdate,
    },
    {
        name: 'customer/product',
        grow: 2,
        selector: row => <div>
            <di>: {row.journaltype}</di>
            <div> : {row.customername}</div>
            <div> : {row.productname}</div>
            <div style={{backgroundColor:'#F0F0F0'}}> :
            {row.productgrouptype}
            <div style={{ color: "red" }}>({row.createbyName})</div>
            </div>
        </div>,
    },
    {
        name: 'film code',
        // grow: 0.5,
        selector: row => row.filmcode,
    },
    // {
    //     name: 'revision',
    //     grow: 0.2,
    //     selector: row => row.revision,
    // },
    {
        name: 'status flow',
        width: '150px',
        selector: row => row.statusflow === '0000'
            ? <span style={{
                display: 'inline-flex', alignItems: 'center', gap: 5,
                backgroundColor: '#fee2e2', color: '#b91c1c',
                border: '1px solid #fca5a5', borderRadius: 20,
                padding: '3px 10px', fontWeight: 700, fontSize: 11,
                whiteSpace: 'nowrap',
            }}>
                <FaExclamationTriangle size={10} /> ยกเลิกเอกสาร
            </span>
            : <Statusall id={row.journalId} statusNow={row.stateflow} stateSuccesfull={row.stateSuccesfull} />,
    },
    {
        name: 'รออนุมัติ',
        grow: 1.5,
        selector: row => <Flowuserapprove id={row.journalId}
            stateflow={row.stateflow}
            departments={row.departments}
            accountapprove={row.accountapprove} />,
    },
    {
        name: 'job status',
        width: '145px',
        selector: row => (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 5, padding: '4px 0' }}>
                {Number(row.statusprove_Tds) === 1 && (
                    <span style={{
                        display: 'inline-flex', alignItems: 'center', gap: 4,
                        backgroundColor: '#198754', color: '#fff',
                        borderRadius: 12, padding: '3px 9px',
                        fontSize: 11, fontWeight: 600, whiteSpace: 'nowrap'
                    }}>
                        <FaCheckCircle size={10} /> Proof Job
                    </span>
                )}
                {row.QuarityStatus > 0 && (
                    <PopUpCheckList tdsCode={row.tdscode} />
                )}
            </div>
        ),
    },
    {
        name: 'confirm job',
        width: '110px',
        selector: row => (
            <div>
                {Number(row.statusConfirm) === 1 && (
                    <span style={{
                        display: 'inline-flex', alignItems: 'center', gap: 4,
                        backgroundColor: '#198754', color: '#fff',
                        borderRadius: 12, padding: '3px 10px',
                        fontSize: 11, fontWeight: 600, whiteSpace: 'nowrap'
                    }}>
                        <FaCheckCircle size={10} /> Approve
                    </span>
                )}
            </div>
        ),
    },


];

const customStyles = {
    headRow: {
        style: {
            border: 'none',
            backgroundColor: '#28B463'
        },
    },
    headCells: {
        style: {
            color: '#ffff',
            fontSize: '14px',
        },
    },
    rows: {
        highlightOnHoverStyle: {
            backgroundColor: 'rgb(230, 244, 244)',
            borderBottomColor: '#FFFFFF',
            borderRadius: '25px',
            outline: '1px solid #FFFFFF',
        },
    },
    pagination: {
        style: {
            border: 'none',
        },
    },
};



const Tablejournalallstatus = (datatable) => {
    var dataresult = datatable.datatable;

    return (

        <DataTable
            columns={columns}
            data={dataresult}
            // selectableRows
            pagination
            customStyles={customStyles}
            highlightOnHover
        />
    )
}

export default Tablejournalallstatus